module.exports = __webpack_public_path__ + "static/dontdie-ceb990b7b7f9b9b0da652ae069a94360.jpg";